import { render, staticRenderFns } from "./validationHint-editor.vue?vue&type=template&id=61b15174&scoped=true&"
import script from "./validationHint-editor.vue?vue&type=script&lang=js&"
export * from "./validationHint-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b15174",
  null
  
)

export default component.exports